import { render, staticRenderFns } from "./RoomTop.vue?vue&type=template&id=090789bd&"
import script from "./RoomTop.vue?vue&type=script&lang=js&"
export * from "./RoomTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports